<div
  class="min-h-screen"
  [ngStyle]="getBackgroundStyles()"
>
  <app-block-list [blockIdList]="body"></app-block-list>
  <router-outlet></router-outlet>
</div>
